import ENV from "../../env";
import getAuthHeaders from "../authHeaders";

const updateUser = async (userId, updatedUser) => {
  try {
    const headers = await getAuthHeaders();
    
    const response = await fetch(
      `${ENV.firebaseApiUrl}/user/update/${userId}`,
      {
        method: "PUT",
        headers,
        body: JSON.stringify({
          user: updatedUser,
        }),
      }
    );

    if (!response.ok) {
      console.error("Response not ok:", response.statusText);
      throw new Error("Bidouba user failed: " + response.statusText);
    }


    return true;
  } catch (error) {
    console.error("Bidoubib:", error);
    throw new Error("An error occurred while updating the user.");
  }
};

export default updateUser;
